// @ts-nocheck
// Porte 1:1 de assets/js/app-landing-player.js. Chamar com o DOM pronto
// (src/appLanding.ts cuida disso); lê o JSON #app-landing-app-config.

export function initAppLandingPlayer() {

/**
 * Partilhar + (opcional) player ao vivo na landing app-landing.php
 */
(function () {
    'use strict';

    var cfgEl = document.getElementById('app-landing-app-config') || document.getElementById('app-landing-player-config');
    var audio = document.getElementById('app-landing-stream-audio');
    var playBtn = document.querySelector('.app-landing-mockup-play');
    var shareBtn = document.querySelector('.app-landing-mockup-share');
    if (!cfgEl) return;

    var cfg;
    try {
        cfg = JSON.parse(cfgEl.textContent || '{}');
    } catch (e) {
        return;
    }

    var streamUrl = (cfg.streamUrl || '').trim();
    var hasPlayer = !!(streamUrl && audio && playBtn);

    var hlsInstance = null;
    var streamBound = false;

    /** Mesmo mockup do botão play (evita sincronizar outro .app-mock-screen se o markup mudar). */
    var mockScreenEl = playBtn ? playBtn.closest('.app-mock-screen') : null;
    if (!mockScreenEl) {
        mockScreenEl = document.querySelector('.app-mock-screen');
    }
    var eqEl = mockScreenEl ? mockScreenEl.querySelector('.app-mock-equalizer') : document.querySelector('.app-mock-equalizer');
    var eqSpans = eqEl ? Array.prototype.slice.call(eqEl.querySelectorAll('span')) : [];
    var audioCtx = null;
    var analyser = null;
    var freqData = null;
    var eqRaf = null;
    var mediaWired = false;
    var mediaWireFailed = false;
    var prefersReduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function ensureAudioCtx() {
        if (prefersReduceMotion) return;
        if (!window.AudioContext && !window.webkitAudioContext) return;
        if (!audioCtx) {
            audioCtx = new (window.AudioContext || window.webkitAudioContext)();
        }
        if (audioCtx.state === 'suspended') {
            audioCtx.resume().catch(function () {});
        }
    }

    function stopEqLive() {
        if (eqRaf) {
            cancelAnimationFrame(eqRaf);
            eqRaf = null;
        }
        if (eqEl) {
            eqEl.classList.remove('app-mock-equalizer--live');
        }
        if (mockScreenEl) {
            mockScreenEl.setAttribute('data-eq-active', '0');
        }
        eqSpans.forEach(function (sp) {
            sp.style.removeProperty('transform');
            sp.style.removeProperty('opacity');
        });
    }

    function eqFrame() {
        if (!analyser || !audio || audio.paused) {
            stopEqLive();
            return;
        }
        analyser.getByteFrequencyData(freqData);
        var n = eqSpans.length;
        if (!n) return;
        var bl = analyser.frequencyBinCount;
        var maxBin = Math.max(8, Math.floor(bl * 0.42));
        var i;
        for (i = 0; i < n; i++) {
            var t0 = (i / n) * maxBin;
            var t1 = ((i + 1) / n) * maxBin;
            var start = Math.floor(t0);
            var end = Math.floor(t1);
            if (end <= start) end = start + 1;
            var sum = 0;
            var j;
            for (j = start; j < end; j++) sum += freqData[j];
            var v = sum / (end - start) / 255;
            var bassWeight = 1 + (1 - i / Math.max(1, n - 1)) * 0.4;
            v = Math.min(1, v * bassWeight);
            var scale = 0.18 + v * 1.02;
            if (scale > 1.14) scale = 1.14;
            eqSpans[i].style.transform = 'scaleY(' + scale + ')';
        }
        if (audio.paused) {
            stopEqLive();
            return;
        }
        eqRaf = requestAnimationFrame(eqFrame);
    }

    function tryWireAnalyser() {
        if (prefersReduceMotion || mediaWired || mediaWireFailed || !hasPlayer || !audio || !audioCtx) {
            return;
        }
        try {
            var source = audioCtx.createMediaElementSource(audio);
            analyser = audioCtx.createAnalyser();
            analyser.fftSize = 256;
            analyser.smoothingTimeConstant = 0.72;
            source.connect(analyser);
            analyser.connect(audioCtx.destination);
            freqData = new Uint8Array(analyser.frequencyBinCount);
            mediaWired = true;
        } catch (err) {
            mediaWireFailed = true;
            analyser = null;
        }
    }

    function startEqIfPossible() {
        if (prefersReduceMotion || !hasPlayer || !audio || audio.paused) return;
        ensureAudioCtx();
        tryWireAnalyser();
        if (analyser && eqEl && eqSpans.length) {
            eqEl.classList.add('app-mock-equalizer--live');
            if (!eqRaf) {
                eqRaf = requestAnimationFrame(eqFrame);
            }
        }
    }

    function loadScript(src, done) {
        var s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = function () { done(null); };
        s.onerror = function () { done(new Error('load')); };
        document.head.appendChild(s);
    }

    function destroyHls() {
        if (hlsInstance) {
            try {
                hlsInstance.destroy();
            } catch (e) { /* ignore */ }
            hlsInstance = null;
        }
    }

    function bindStream(callback) {
        if (!audio) return;
        try {
            audio.crossOrigin = 'anonymous';
        } catch (e) { /* ignore */ }
        destroyHls();
        audio.removeAttribute('src');
        audio.load();

        var isM3u8 = /\.m3u8(\?|$)/i.test(streamUrl);

        if (isM3u8 && window.Hls && window.Hls.isSupported()) {
            hlsInstance = new window.Hls({
                maxBufferLength: 30,
                liveSyncDurationCount: 3,
            });
            hlsInstance.loadSource(streamUrl);
            hlsInstance.attachMedia(audio);
            hlsInstance.on(window.Hls.Events.MANIFEST_PARSED, function () {
                callback(null);
            });
            hlsInstance.on(window.Hls.Events.ERROR, function (_, data) {
                if (data && data.fatal) {
                    callback(new Error('hls'));
                }
            });
            return;
        }

        if (isM3u8 && audio.canPlayType('application/vnd.apple.mpegurl')) {
            audio.src = streamUrl;
            callback(null);
            return;
        }

        audio.src = streamUrl;
        callback(null);
    }

    function ensureStreamThen(fn) {
        if (!hasPlayer) return;
        if (streamBound) {
            fn();
            return;
        }
        var isM3u8 = /\.m3u8(\?|$)/i.test(streamUrl);
        var needHls = isM3u8 && !(audio.canPlayType('application/vnd.apple.mpegurl')) && typeof window.Hls === 'undefined';

        function afterBind(err) {
            if (err) {
                setLoading(false);
                showToast(cfg.streamError || '');
                return;
            }
            streamBound = true;
            fn();
        }

        if (needHls) {
            loadScript('https://cdnjs.cloudflare.com/ajax/libs/hls.js/1.5.7/hls.min.js', function (err) {
                if (err || typeof window.Hls === 'undefined') {
                    setLoading(false);
                    showToast(cfg.streamError || '');
                    return;
                }
                bindStream(afterBind);
            });
            return;
        }
        bindStream(afterBind);
    }

    function setLoading(on) {
        if (!playBtn) return;
        playBtn.classList.toggle('is-loading', !!on);
        playBtn.setAttribute('aria-busy', on ? 'true' : 'false');
        if (mockScreenEl) {
            mockScreenEl.classList.toggle('is-loading', !!on);
        }
    }

    function setPlayIcon(playing) {
        if (!playBtn) return;
        var icon = playBtn.querySelector('.app-landing-mockup-play-icon-main');
        if (icon) {
            icon.className = playing ? 'fas fa-pause app-landing-mockup-play-icon-main' : 'fas fa-play app-landing-mockup-play-icon-main';
        }
        playBtn.setAttribute('aria-label', playing ? (cfg.ariaPause || '') : (cfg.ariaPlay || ''));
        playBtn.classList.toggle('is-playing', !!playing);
        if (mockScreenEl) {
            mockScreenEl.classList.toggle('is-playing', !!playing);
            mockScreenEl.setAttribute('data-eq-active', playing ? '1' : '0');
        }
    }

    function showToast(msg) {
        if (!msg) return;
        var toast = document.createElement('div');
        toast.className = 'app-landing-toast';
        toast.setAttribute('role', 'alert');
        toast.textContent = msg;
        document.body.appendChild(toast);
        requestAnimationFrame(function () { toast.classList.add('show'); });
        setTimeout(function () {
            toast.classList.remove('show');
            setTimeout(function () { toast.remove(); }, 300);
        }, 3200);
    }

    if (hasPlayer) {
        /* Garante estado inicial silencioso do equalizador antes do
           primeiro play — defesa em profundidade caso atributos venham
           reaplicados pelo back-forward cache. */
        if (mockScreenEl) {
            mockScreenEl.setAttribute('data-eq-active', '0');
        }

        /** Em streams ao vivo (Icecast/Shoutcast), alguns servidores fecham
         *  a conexao apos pause. Reusar o mesmo `audio` no proximo play
         *  resulta em erro silencioso. Marcamos o stream como "nao vinculado"
         *  para forcar re-bind em ensureStreamThen() no proximo click play. */
        var lastPlayInvocationId = 0;

        playBtn.addEventListener('click', function () {
            if (!audio.paused) {
                audio.pause();
                setLoading(false);
                setPlayIcon(false);
                stopEqLive();
                /* Forca re-bind no proximo play — evita "audio morto"
                   apos servidor fechar a conexao. */
                streamBound = false;
                return;
            }
            if (!prefersReduceMotion) {
                ensureAudioCtx();
            }
            setLoading(true);
            /* Equalizador silenciado durante loading; so volta a animar no
               evento `playing`. */
            if (mockScreenEl) {
                mockScreenEl.setAttribute('data-eq-active', '0');
            }
            var invocationId = ++lastPlayInvocationId;
            ensureStreamThen(function () {
                /* Outro clique aconteceu enquanto carregavamos — descarta. */
                if (invocationId !== lastPlayInvocationId) return;
                var p = audio.play();
                if (p && typeof p.then === 'function') {
                    p.catch(function (err) {
                        /* AbortError = play() interrompida por pause()
                           ou nova chamada a load()/play(). Nao e falha
                           do stream; nao mostrar toast. */
                        var name = err && err.name;
                        if (name === 'AbortError') {
                            setLoading(false);
                            return;
                        }
                        setLoading(false);
                        setPlayIcon(false);
                        stopEqLive();
                        showToast(cfg.streamError || '');
                    });
                }
            });
        });

        audio.addEventListener('playing', function () {
            if (audio.paused) {
                return;
            }
            setLoading(false);
            setPlayIcon(true);
            startEqIfPossible();
        });
        audio.addEventListener('waiting', function () {
            if (!audio.paused) {
                setLoading(true);
            }
        });
        audio.addEventListener('canplay', function () {
            if (!audio.paused) {
                setLoading(false);
            }
        });
        audio.addEventListener('pause', function () {
            setLoading(false);
            setPlayIcon(false);
            stopEqLive();
            /* Mesma garantia do click: re-bind no proximo play. Cobre tambem
               pauses programaticos (ex.: outra aba toma audio focus). */
            streamBound = false;
        });
        audio.addEventListener('ended', function () {
            setLoading(false);
            setPlayIcon(false);
            stopEqLive();
            streamBound = false;
        });
        audio.addEventListener('error', function () {
            setLoading(false);
            setPlayIcon(false);
            stopEqLive();
            streamBound = false;
            showToast(cfg.streamError || '');
        });

        window.addEventListener('beforeunload', destroyHls);
    } else if (mockScreenEl) {
        mockScreenEl.setAttribute('data-eq-active', '0');
    }

    if (shareBtn) {
        shareBtn.addEventListener('click', function () {
            var url = cfg.shareUrl || window.location.href;
            var title = cfg.shareTitle || document.title;

            if (navigator.share) {
                navigator.share({ title: title, text: title, url: url }).catch(function (err) {
                    if (err && err.name === 'AbortError') return;
                    copyShareUrl(url);
                });
            } else {
                copyShareUrl(url);
            }
        });
    }

    function copyShareUrl(url) {
        function ok() {
            showToast(cfg.shareCopied || '');
        }
        function fail() {
            showToast(url);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(ok).catch(fail);
        } else {
            fail();
        }
    }

    function showMockToast(text) {
        if (!text) return;
        var existing = document.querySelector('.app-landing-toast.app-mock-toast');
        if (existing) {
            existing.classList.remove('show');
            setTimeout(function () { try { existing.remove(); } catch (e) {} }, 200);
        }
        var t = document.createElement('div');
        t.className = 'app-landing-toast app-mock-toast';
        t.setAttribute('role', 'status');
        t.textContent = text;
        document.body.appendChild(t);
        requestAnimationFrame(function () { t.classList.add('show'); });
        setTimeout(function () {
            t.classList.remove('show');
            setTimeout(function () { try { t.remove(); } catch (e) {} }, 300);
        }, 2600);
    }

    function initAppLandingSchedule(config) {
        var scheduleBtns = document.querySelectorAll('[data-app-mock-schedule]');
        if (!scheduleBtns.length) {
            return;
        }

        var modal = document.getElementById('app-landing-schedule-modal');
        var subtitleEl = document.getElementById('app-landing-schedule-modal-subtitle');
        var stateEl = document.getElementById('app-landing-schedule-state');
        var listEl = document.getElementById('app-landing-schedule-list');

        var scheduleEnabled = !!config.scheduleEnabled && !!(config.scheduleFetchUrl || '').trim();
        var scheduleCache = null;
        var lastScheduleFocus = null;

        var PT_DAY = {
            'segunda-feira': 'Mon',
            'terça-feira': 'Tue',
            'terca-feira': 'Tue',
            'quarta-feira': 'Wed',
            'quinta-feira': 'Thu',
            'sexta-feira': 'Fri',
            'sábado': 'Sat',
            'sabado': 'Sat',
            'domingo': 'Sun'
        };

        var DAY_ORDER_JS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

        function todayDayCode() {
            return DAY_ORDER_JS[new Date().getDay()];
        }

        function normalizeSchedulePayload(data) {
            var byDay = { Mon: [], Tue: [], Wed: [], Thu: [], Fri: [], Sat: [], Sun: [] };
            if (!data || !data.programacao || typeof data.programacao !== 'object') {
                return byDay;
            }
            Object.keys(data.programacao).forEach(function (key) {
                var dayData = data.programacao[key];
                if (!dayData || typeof dayData !== 'object') {
                    return;
                }
                var code = (typeof dayData.dia_codigo === 'string' && dayData.dia_codigo) || PT_DAY[key] || null;
                if (!code || !byDay[code] || !Array.isArray(dayData.programas)) {
                    return;
                }
                dayData.programas.forEach(function (p) {
                    if (!p || typeof p !== 'object') {
                        return;
                    }
                    byDay[code].push({
                        start: String(p.horario_inicio || ''),
                        end: String(p.horario_fim || ''),
                        title: String(p.programa || ''),
                        detail: String(p.apresentador || '')
                    });
                });
            });
            return byDay;
        }

        function setScheduleUi(mode, message) {
            if (!stateEl || !listEl) {
                return;
            }
            if (mode === 'list') {
                stateEl.hidden = true;
                stateEl.textContent = '';
                listEl.hidden = false;
                return;
            }
            listEl.hidden = true;
            listEl.innerHTML = '';
            stateEl.hidden = false;
            stateEl.textContent = message || '';
            stateEl.setAttribute('data-state', mode);
        }

        function renderScheduleList(items) {
            if (!listEl) {
                return;
            }
            listEl.innerHTML = '';
            items.forEach(function (it) {
                var li = document.createElement('li');
                li.className = 'app-landing-schedule-item';
                var time = document.createElement('div');
                time.className = 'app-landing-schedule-item__time';
                var tr = (it.start || '') + (it.end ? ' – ' + it.end : '');
                time.textContent = tr;
                var main = document.createElement('div');
                main.className = 'app-landing-schedule-item__main';
                var title = document.createElement('div');
                title.className = 'app-landing-schedule-item__title';
                title.textContent = it.title || '';
                main.appendChild(title);
                if (it.detail) {
                    var det = document.createElement('div');
                    det.className = 'app-landing-schedule-item__detail';
                    det.textContent = it.detail;
                    main.appendChild(det);
                }
                li.appendChild(time);
                li.appendChild(main);
                listEl.appendChild(li);
            });
            setScheduleUi('list');
        }

        function updateSubtitle(dayCode) {
            if (!subtitleEl) {
                return;
            }
            var names = config.scheduleDayNames || {};
            var loc = config.scheduleLocale || 'pt-BR';
            var dayName = names[dayCode] || dayCode;
            var d = new Date();
            var datePart = '';
            try {
                datePart = d.toLocaleDateString(loc, { day: 'numeric', month: 'long' });
            } catch (e2) {
                datePart = d.toLocaleDateString();
            }
            subtitleEl.textContent = dayName + ' · ' + datePart;
        }

        function openScheduleModal() {
            if (!modal) {
                return;
            }
            lastScheduleFocus = document.activeElement;
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('app-landing-schedule-modal-open');
            var closeBtn = modal.querySelector('.app-landing-schedule-modal__close');
            if (closeBtn) {
                closeBtn.focus();
            }
        }

        function closeScheduleModal() {
            if (!modal) {
                return;
            }
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('app-landing-schedule-modal-open');
            if (lastScheduleFocus && typeof lastScheduleFocus.focus === 'function') {
                lastScheduleFocus.focus();
            }
            lastScheduleFocus = null;
        }

        function loadAndRenderSchedule() {
            var dayCode = todayDayCode();
            updateSubtitle(dayCode);

            if (scheduleCache) {
                var cached = scheduleCache[dayCode] || [];
                if (!cached.length) {
                    setScheduleUi('empty', config.scheduleEmpty || '');
                } else {
                    renderScheduleList(cached);
                }
                return;
            }

            setScheduleUi('loading', config.scheduleLoading || '');

            fetch(config.scheduleFetchUrl, { credentials: 'same-origin' })
                .then(function (r) {
                    if (!r.ok) {
                        throw new Error('http');
                    }
                    return r.json();
                })
                .then(function (data) {
                    if (data && data.success === false) {
                        throw new Error('api');
                    }
                    scheduleCache = normalizeSchedulePayload(data);
                    var rows = scheduleCache[dayCode] || [];
                    if (!rows.length) {
                        setScheduleUi('empty', config.scheduleEmpty || '');
                    } else {
                        renderScheduleList(rows);
                    }
                })
                .catch(function () {
                    scheduleCache = null;
                    setScheduleUi('error', config.scheduleError || '');
                });
        }

        if (modal) {
            modal.querySelectorAll('[data-app-landing-schedule-close]').forEach(function (el) {
                el.addEventListener('click', closeScheduleModal);
            });
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && modal.classList.contains('is-open')) {
                    closeScheduleModal();
                }
            });
        }

        scheduleBtns.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                if (!scheduleEnabled) {
                    showMockToast(config.schedulePlaceholder || '');
                    return;
                }
                if (!modal) {
                    showMockToast(config.schedulePlaceholder || '');
                    return;
                }
                openScheduleModal();
                loadAndRenderSchedule();
            });
        });
    }

    initAppLandingSchedule(cfg);

    function isAppLandingPwaStandalone() {
        try {
            if (window.matchMedia('(display-mode: standalone)').matches) {
                return true;
            }
        } catch (e1) { /* ignore */ }
        try {
            if (window.matchMedia('(display-mode: fullscreen)').matches && window.navigator.standalone) {
                return true;
            }
        } catch (e2) { /* ignore */ }
        if (typeof window.navigator.standalone !== 'undefined' && window.navigator.standalone) {
            return true;
        }
        return false;
    }

    function syncAppLandingViewportHeight() {
        var h = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
        document.documentElement.style.setProperty('--app-vh', Math.round(h) + 'px');
    }

    function initAppLandingViewportHeight() {
        document.documentElement.classList.add('app-landing-vh-root');
        syncAppLandingViewportHeight();
        window.addEventListener('resize', syncAppLandingViewportHeight, { passive: true });
        window.addEventListener('orientationchange', syncAppLandingViewportHeight, { passive: true });
        window.addEventListener('pageshow', syncAppLandingViewportHeight, { passive: true });
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', syncAppLandingViewportHeight, { passive: true });
        }
    }

    initAppLandingViewportHeight();

    function initAppLandingBack() {
        if (isAppLandingPwaStandalone()) {
            document.documentElement.classList.add('app-landing-pwa-root');
            document.body.classList.add('app-landing-page--pwa-standalone');
            syncAppLandingViewportHeight();
            return;
        }
        document.querySelectorAll('[data-app-mock-back]').forEach(function (link) {
            link.addEventListener('click', function (e) {
                var referrer = document.referrer || '';
                var sameOrigin = false;
                try {
                    if (referrer) {
                        sameOrigin = new URL(referrer, window.location.href).origin === window.location.origin;
                    }
                } catch (err) { /* ignore */ }
                if (sameOrigin && window.history.length > 1) {
                    e.preventDefault();
                    history.back();
                }
            });
        });
    }

    initAppLandingBack();

    /**
     * Drawer esquerdo de noticias locais.
     *
     * Fonte: radio.php?ajax=news&id={radioId} decodifica
     * _enrichment.news (base64) e devolve articles[] ja sanitizados.
     *
     * Estados (atributo data-state em #app-landing-news-state):
     *   loading | error | empty
     *
     * Cache em memoria: depois do primeiro fetch bem-sucedido, abertura
     * subsequente reaproveita os artigos sem refazer a request.
     */
    function initAppLandingNews(config) {
        var newsEnabled = !!(config && config.newsEnabled && config.newsFetchUrl);
        var newsBtns = Array.prototype.slice.call(document.querySelectorAll('[data-app-mock-news]'));
        if (!newsBtns.length) return;

        var drawer    = document.getElementById('app-landing-news-drawer');
        var stateEl   = document.getElementById('app-landing-news-state');
        var listEl    = document.getElementById('app-landing-news-list');
        var newsCache = null;
        var lastFocus = null;

        function escapeHtml(s) {
            return String(s == null ? '' : s)
                .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        }

        function showMockToastLocal(msg) {
            if (!msg) return;
            var toast = document.createElement('div');
            toast.className = 'app-landing-toast';
            toast.setAttribute('role', 'status');
            toast.textContent = msg;
            document.body.appendChild(toast);
            requestAnimationFrame(function () { toast.classList.add('show'); });
            setTimeout(function () {
                toast.classList.remove('show');
                setTimeout(function () { toast.remove(); }, 320);
            }, 2600);
        }

        function setNewsUi(state, message) {
            if (!stateEl || !listEl) return;
            if (state === 'list') {
                stateEl.hidden = true;
                stateEl.textContent = '';
                listEl.hidden = false;
                return;
            }
            listEl.hidden = true;
            listEl.innerHTML = '';
            stateEl.hidden = false;
            stateEl.setAttribute('data-state', state);
            stateEl.textContent = message || '';
        }

        function openNewsDrawer() {
            if (!drawer) return;
            lastFocus = document.activeElement;
            drawer.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');
            document.body.classList.add('app-landing-news-drawer-open');
            var closeBtn = drawer.querySelector('.app-landing-news-drawer__close');
            if (closeBtn) closeBtn.focus();
        }

        function closeNewsDrawer() {
            if (!drawer) return;
            drawer.classList.remove('is-open');
            drawer.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('app-landing-news-drawer-open');
            if (lastFocus && typeof lastFocus.focus === 'function') {
                lastFocus.focus();
            }
            lastFocus = null;
        }

        function renderArticle(article) {
            var title       = escapeHtml(article.title || '');
            var url         = escapeHtml(article.url || '');
            var description = escapeHtml(article.description || '');
            var image       = escapeHtml(article.image || '');
            var published   = escapeHtml(article.published || '');
            var updated     = escapeHtml(article.updated || '');
            var openLabel   = escapeHtml(config.newsOpenArticle || 'Ler');
            var labelPub    = escapeHtml(config.newsLabelPublished || '');
            var labelUpd    = escapeHtml(config.newsLabelUpdated || '');

            var imageHtml = image
                ? '<div class="app-landing-news-item__media"><img src="' + image + '" alt="" loading="lazy" decoding="async" onerror="this.parentNode.style.display=\'none\'"></div>'
                : '';

            var metaParts = [];
            if (published) metaParts.push('<span class="app-landing-news-item__meta-row">' + labelPub + ' ' + published + '</span>');
            if (updated && updated !== published) metaParts.push('<span class="app-landing-news-item__meta-row">' + labelUpd + ' ' + updated + '</span>');
            var metaHtml = metaParts.length
                ? '<div class="app-landing-news-item__meta">' + metaParts.join('') + '</div>'
                : '';

            var descHtml = description
                ? '<p class="app-landing-news-item__desc">' + description + '</p>'
                : '';

            return '<li class="app-landing-news-item">'
                + '<a class="app-landing-news-item__link" href="' + url + '" target="_blank" rel="noopener noreferrer">'
                +   imageHtml
                +   '<div class="app-landing-news-item__body">'
                +     '<h3 class="app-landing-news-item__title">' + title + '</h3>'
                +     descHtml
                +     metaHtml
                +     '<span class="app-landing-news-item__cta">' + openLabel + ' <i class="fa-solid fa-arrow-up-right-from-square" aria-hidden="true"></i></span>'
                +   '</div>'
                + '</a>'
                + '</li>';
        }

        function renderArticles(articles) {
            if (!articles || !articles.length) {
                setNewsUi('empty', config.newsEmpty || '');
                return;
            }
            listEl.innerHTML = articles.map(renderArticle).join('');
            setNewsUi('list');
        }

        function loadAndRenderNews() {
            if (Array.isArray(newsCache)) {
                renderArticles(newsCache);
                return;
            }
            setNewsUi('loading', config.newsLoading || '');

            fetch(config.newsFetchUrl, { credentials: 'same-origin' })
                .then(function (r) {
                    if (!r.ok) throw new Error('http');
                    return r.json();
                })
                .then(function (data) {
                    if (!data || data.success === false || !Array.isArray(data.articles)) {
                        throw new Error('api');
                    }
                    newsCache = data.articles;
                    renderArticles(newsCache);
                })
                .catch(function () {
                    newsCache = null;
                    setNewsUi('error', config.newsError || '');
                });
        }

        if (drawer) {
            drawer.querySelectorAll('[data-app-landing-news-close]').forEach(function (el) {
                el.addEventListener('click', closeNewsDrawer);
            });
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
                    closeNewsDrawer();
                }
            });
        }

        newsBtns.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                if (!newsEnabled) {
                    showMockToastLocal(config.newsEmpty || '');
                    return;
                }
                if (!drawer) {
                    showMockToastLocal(config.newsError || '');
                    return;
                }
                openNewsDrawer();
                loadAndRenderNews();
            });
        });
    }

    initAppLandingNews(cfg);

    /**
     * Sleep timer — agenda audio.pause() apos N minutos.
     *
     * Estado:
     *   activeTimerId  → id do setTimeout em curso (null = inativo)
     *   activeMinutes  → minutos originalmente escolhidos (para toast)
     *   activeDeadline → epoch ms quando vai disparar (para futuro UX de
     *                    countdown; nao usado no momento)
     *
     * Integracao com o player:
     *   - Disparo do timer chama audio.pause(). O handler de 'pause' do
     *     player ja faz o resto (atualiza icone, equalizador, etc).
     *   - Se o utilizador pausar manualmente antes do timer, o timer e
     *     cancelado em silencio para nao surpreender depois.
     *   - Se o stream cair (evento 'error'), o timer tambem e cancelado.
     */
    function initAppLandingSleep(config) {
        var sleepEnabled = !!(config && config.sleepEnabled);
        var sleepBtns = Array.prototype.slice.call(document.querySelectorAll('[data-app-mock-sleep]'));
        if (!sleepBtns.length) return;

        var modal       = document.getElementById('app-landing-sleep-modal');
        var optionBtns  = modal ? modal.querySelectorAll('[data-app-landing-sleep-minutes]') : [];
        var cancelBtn   = modal ? modal.querySelector('[data-app-landing-sleep-cancel]') : null;
        var closers     = modal ? modal.querySelectorAll('[data-app-landing-sleep-close]') : [];
        var subtitleEl  = modal ? modal.querySelector('#app-landing-sleep-modal-subtitle') : null;
        var subtitleDefault = subtitleEl ? subtitleEl.textContent : '';
        var audio       = document.getElementById('app-landing-stream-audio');

        var activeTimerId  = null;   /* id do setTimeout do pause final */
        var activeMinutes  = 0;       /* minutos originalmente escolhidos */
        var activeDeadline = 0;       /* epoch ms em que o timer dispara */
        var tickIntervalId = null;    /* id do setInterval do countdown */
        var lastFocus      = null;

        function showSleepToast(msg) {
            if (!msg) return;
            var toast = document.createElement('div');
            toast.className = 'app-landing-toast';
            toast.setAttribute('role', 'status');
            toast.textContent = msg;
            document.body.appendChild(toast);
            requestAnimationFrame(function () { toast.classList.add('show'); });
            setTimeout(function () {
                toast.classList.remove('show');
                setTimeout(function () { toast.remove(); }, 320);
            }, 2800);
        }

        /* Formato "1 h", "30 min" — usado no toast inicial. */
        function formatMinutesLabel(minutes) {
            if (minutes >= 60 && minutes % 60 === 0) {
                var hours = minutes / 60;
                return hours + ' ' + (config.sleepLabelHour || 'h');
            }
            return minutes + ' ' + (config.sleepLabelMinutes || 'min');
        }

        /* Formato compacto "1h 5m", "12m 30s", "45s" — usado no botao
           e subtitle durante a contagem regressiva. */
        function formatRemaining(ms) {
            if (ms <= 0) return '0' + (config.sleepLabelSeconds || 's');
            var totalSec = Math.ceil(ms / 1000);
            var hours = Math.floor(totalSec / 3600);
            var mins  = Math.floor((totalSec % 3600) / 60);
            var secs  = totalSec % 60;
            var h = config.sleepLabelHour || 'h';
            var m = config.sleepLabelMinutesShort || 'm';
            var s = config.sleepLabelSeconds || 's';
            if (hours > 0) {
                /* Acima de 1 hora: "1h 5m" (sem segundos para reduzir
                   atualizacoes/economia de re-render). */
                return hours + h + ' ' + mins + m;
            }
            if (mins > 0) {
                /* Entre 1 min e 1 h: "12m 30s" — segundos so quando perto. */
                if (mins < 5) {
                    return mins + m + ' ' + (secs < 10 ? '0' : '') + secs + s;
                }
                return mins + m;
            }
            /* Ultimo minuto: contagem em segundos. */
            return secs + s;
        }

        function updateCountdownUi() {
            if (activeTimerId === null) return;
            var remaining = activeDeadline - Date.now();
            if (remaining < 0) remaining = 0;
            var label = formatRemaining(remaining);
            sleepBtns.forEach(function (btn) {
                var timeEl = btn.querySelector('.app-mock-sleep-btn__time');
                if (timeEl) {
                    timeEl.textContent = label;
                }
            });
            if (subtitleEl && modal && modal.classList.contains('is-open')) {
                var template = config.sleepRemainingTemplate || '';
                subtitleEl.textContent = template
                    ? template.replace('{time}', label)
                    : label;
            }
        }

        function startTick() {
            stopTick();
            updateCountdownUi();
            /* 1 segundo e suficiente — granularidade abaixo disso e ruido.
               Ate menos: quando faltar pouco, a UI ja entra em modo "segundos". */
            tickIntervalId = window.setInterval(updateCountdownUi, 1000);
        }

        function stopTick() {
            if (tickIntervalId !== null) {
                clearInterval(tickIntervalId);
                tickIntervalId = null;
            }
        }

        function syncBtnState() {
            var isActive = activeTimerId !== null;
            sleepBtns.forEach(function (btn) {
                btn.classList.toggle('is-active', isActive);
                var timeEl = btn.querySelector('.app-mock-sleep-btn__time');
                if (timeEl) {
                    if (isActive) {
                        timeEl.removeAttribute('hidden');
                    } else {
                        timeEl.setAttribute('hidden', '');
                        timeEl.textContent = '';
                    }
                }
            });
            if (cancelBtn) {
                if (isActive) {
                    cancelBtn.removeAttribute('hidden');
                } else {
                    cancelBtn.setAttribute('hidden', '');
                }
            }
            optionBtns.forEach(function (opt) {
                var mins = parseInt(opt.getAttribute('data-app-landing-sleep-minutes'), 10);
                opt.classList.toggle('is-selected', isActive && mins === activeMinutes);
            });
            /* Subtitle: padrao quando sem timer; com timer atualiza via tick. */
            if (subtitleEl && !isActive) {
                subtitleEl.textContent = subtitleDefault;
            }
            if (isActive) {
                updateCountdownUi();
            }
        }

        function clearActiveTimer(silent) {
            if (activeTimerId !== null) {
                clearTimeout(activeTimerId);
                activeTimerId = null;
                activeMinutes = 0;
                activeDeadline = 0;
                stopTick();
                if (!silent) {
                    showSleepToast(config.sleepCanceledToast || '');
                }
                syncBtnState();
            }
        }

        function startTimer(minutes) {
            if (!audio) return;
            if (activeTimerId !== null) {
                clearTimeout(activeTimerId);
                activeTimerId = null;
                stopTick();
            }

            if (audio.paused) {
                showSleepToast(config.sleepNotPlayingToast || '');
                return;
            }

            activeMinutes = minutes;
            activeDeadline = Date.now() + minutes * 60 * 1000;
            activeTimerId = window.setTimeout(function () {
                activeTimerId = null;
                activeMinutes = 0;
                activeDeadline = 0;
                stopTick();
                try { audio.pause(); } catch (e) { /* ignore */ }
                showSleepToast(config.sleepPausedToast || '');
                syncBtnState();
            }, minutes * 60 * 1000);

            var template = config.sleepActiveToast || '';
            var msg = template.replace('{time}', formatMinutesLabel(minutes));
            showSleepToast(msg);
            syncBtnState();
            startTick();
        }

        function openModal() {
            if (!modal) return;
            lastFocus = document.activeElement;
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            sleepBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
            document.body.classList.add('app-landing-sleep-modal-open');
            syncBtnState();
            var first = modal.querySelector('[data-app-landing-sleep-minutes]');
            if (first) first.focus();
        }

        function closeModal() {
            if (!modal) return;
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            sleepBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
            document.body.classList.remove('app-landing-sleep-modal-open');
            if (lastFocus && typeof lastFocus.focus === 'function') {
                lastFocus.focus();
            }
            lastFocus = null;
        }

        sleepBtns.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                if (!sleepEnabled) return;
                openModal();
            });
        });

        if (closers && closers.length) {
            Array.prototype.forEach.call(closers, function (el) {
                el.addEventListener('click', closeModal);
            });
        }

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
                closeModal();
            }
        });

        if (optionBtns && optionBtns.length) {
            Array.prototype.forEach.call(optionBtns, function (opt) {
                opt.addEventListener('click', function () {
                    var mins = parseInt(opt.getAttribute('data-app-landing-sleep-minutes'), 10);
                    if (!isFinite(mins) || mins <= 0) return;
                    startTimer(mins);
                    closeModal();
                });
            });
        }

        if (cancelBtn) {
            cancelBtn.addEventListener('click', function () {
                clearActiveTimer(false);
                closeModal();
            });
        }

        /* Pause manual ou erro do stream cancela o timer silenciosamente:
           se o utilizador parou a radio, nao faz sentido o timer disparar
           depois e mostrar um toast confuso. */
        if (audio) {
            audio.addEventListener('pause', function () {
                if (activeTimerId !== null) clearActiveTimer(true);
            });
            audio.addEventListener('error', function () {
                if (activeTimerId !== null) clearActiveTimer(true);
            });
            audio.addEventListener('ended', function () {
                if (activeTimerId !== null) clearActiveTimer(true);
            });
        }

        syncBtnState();
    }

    initAppLandingSleep(cfg);

    /**
     * Drawer direito de Clima.
     *
     * Fonte: radio.php?ajax=weather&id={radioId} decodifica
     * _enrichment.weather (base64) e devolve um payload normalizado
     * com currentWeather + health (UV / qualidade do ar).
     *
     * Cache em memoria: depois do primeiro fetch bem-sucedido,
     * abertura subsequente reaproveita os dados (clima muda devagar).
     */
    function initAppLandingWeather(config) {
        var hasRadioWeather = !!(config && config.weatherHasRadioSource && config.weatherFetchUrl);
        var weatherAtUrlBase = (config && config.weatherAtUrl) ? String(config.weatherAtUrl) : '';
        if (!weatherAtUrlBase && config && config.weatherFetchUrl) {
            weatherAtUrlBase = String(config.weatherFetchUrl)
                .replace(/[?&]id=\d+/, '')
                .replace(/ajax=weather/, 'ajax=weather_at');
        }
        var weatherEnabled = !!(config && config.weatherEnabled && (config.weatherFetchUrl || weatherAtUrlBase));
        var weatherBtns = Array.prototype.slice.call(document.querySelectorAll('[data-app-mock-weather]'));
        if (!weatherBtns.length) return;

        var drawer  = document.getElementById('app-landing-weather-drawer');
        var stateEl = document.getElementById('app-landing-weather-state');
        var contentEl = document.getElementById('app-landing-weather-content');
        var weatherCacheRadio = null;
        var weatherCacheUser  = null;
        var userCoords        = null;   /* { lat, lon } depois do getCurrentPosition */
        var activeSource      = hasRadioWeather ? 'radio' : 'user'; /* 'radio' | 'user' */
        var lastFocus = null;

        function escapeHtml(s) {
            return String(s == null ? '' : s)
                .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        }

        function setWeatherUi(state, message) {
            if (!stateEl || !contentEl) return;
            if (state === 'content') {
                stateEl.hidden = true;
                stateEl.textContent = '';
                contentEl.hidden = false;
                return;
            }
            contentEl.hidden = true;
            contentEl.innerHTML = '';
            stateEl.hidden = false;
            stateEl.setAttribute('data-state', state);
            stateEl.textContent = message || '';
        }

        function openWeatherDrawer() {
            if (!drawer) return;
            lastFocus = document.activeElement;
            drawer.classList.add('is-open');
            drawer.setAttribute('aria-hidden', 'false');
            document.body.classList.add('app-landing-weather-drawer-open');
            var closeBtn = drawer.querySelector('.app-landing-weather-drawer__close');
            if (closeBtn) closeBtn.focus();
        }

        function closeWeatherDrawer() {
            if (!drawer) return;
            drawer.classList.remove('is-open');
            drawer.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('app-landing-weather-drawer-open');
            if (lastFocus && typeof lastFocus.focus === 'function') {
                lastFocus.focus();
            }
            lastFocus = null;
        }

        function hourFromIso(iso) {
            /* "2026-05-19T14:00:00" → "14h" (puxa hora direto sem timezone shift). */
            var m = String(iso || '').match(/T(\d{2})/);
            return m ? (m[1] + 'h') : '';
        }

        function weatherIconToneFromClass(iconClass, iconTone) {
            if (iconTone) return iconTone;
            var c = String(iconClass || '');
            if (c.indexOf('fa-cloud-moon-rain') >= 0) return 'night-rain';
            if (c.indexOf('fa-cloud-moon') >= 0) return 'night';
            if (c.indexOf('fa-cloud-sun-rain') >= 0) return 'rain-sun';
            if (c.indexOf('fa-cloud-sun') >= 0) return 'sun-cloud';
            if (c.indexOf('fa-cloud-showers-water') >= 0) return 'storm';
            if (c.indexOf('fa-cloud-bolt') >= 0) return 'storm';
            if (c.indexOf('fa-cloud-showers') >= 0) return 'rain';
            if (c.indexOf('fa-cloud-rain') >= 0) return 'rain';
            if (c.indexOf('fa-smog') >= 0) return 'fog';
            if (c.indexOf('fa-moon') >= 0) return 'night';
            if (c.indexOf('fa-sun') >= 0) return 'sun';
            if (c.indexOf('fa-cloud') >= 0) return 'cloud';
            return 'cloud';
        }

        function weatherIconClassList(layoutClass, iconClass, iconTone) {
            var tone = weatherIconToneFromClass(iconClass, iconTone);
            var parts = ['app-landing-weather-icon', 'app-landing-weather-icon--tone-' + tone];
            if (layoutClass) parts.push(layoutClass);
            if (iconClass) parts.push(iconClass);
            return escapeHtml(parts.join(' '));
        }

        function renderHero(weather) {
            var cw = weather.currentWeather;
            var html = '<section class="app-landing-weather-hero">';
            if (weather.location) {
                html += '<div class="app-landing-weather-hero__location">'
                     +   '<i class="fa-solid fa-location-dot" aria-hidden="true"></i>'
                     +   '<span>' + escapeHtml(weather.location) + '</span>'
                     + '</div>';
            }
            html += '<div class="app-landing-weather-hero__head">';
            if (cw.dayWeek) html += '<span class="app-landing-weather-hero__day">' + escapeHtml(cw.dayWeek) + '</span>';
            if (cw.date)    html += '<span class="app-landing-weather-hero__date">' + escapeHtml(cw.date) + '</span>';
            html += '</div>';
            html += '<div class="app-landing-weather-hero__row">';
            html +=   '<div class="app-landing-weather-hero__temp-wrap">';
            html +=     '<span class="app-landing-weather-hero__temp">' + escapeHtml(cw.temperature) + '°</span>';
            if (cw.condition) html += '<span class="app-landing-weather-hero__cond">' + escapeHtml(cw.condition) + '</span>';
            html +=   '</div>';
            html +=   '<i class="' + weatherIconClassList('app-landing-weather-hero__icon', cw.iconClass || 'fas fa-cloud', cw.iconTone) + '" aria-hidden="true"></i>';
            html += '</div>';
            html += '</section>';
            return html;
        }

        function renderHourlyStrip(hourly) {
            /* Mini-strip horizontal: proximas 6-8 horas, sempre visivel
               logo abaixo do hero. */
            if (!Array.isArray(hourly) || !hourly.length) return '';
            var slice = hourly.slice(0, 8);
            var inner = slice.map(function (h) {
                var temp = (h.temperature !== null && h.temperature !== undefined) ? (h.temperature + '°') : '—';
                return '<div class="app-landing-weather-strip__item">'
                     +   '<span class="app-landing-weather-strip__hour">' + escapeHtml(hourFromIso(h.date)) + '</span>'
                     +   '<i class="' + weatherIconClassList('app-landing-weather-strip__icon', h.iconClass || 'fas fa-cloud', h.iconTone) + '" aria-hidden="true"></i>'
                     +   '<span class="app-landing-weather-strip__temp">' + escapeHtml(temp) + '</span>'
                     + '</div>';
            }).join('');
            return '<div class="app-landing-weather-strip" role="list">' + inner + '</div>';
        }

        function renderNowTab(weather) {
            var cw = weather.currentWeather || {};

            var html = '<div class="app-landing-weather-grid">';
            if (cw.humidity !== '') {
                html += '<div class="app-landing-weather-card">'
                     +   '<div class="app-landing-weather-card__head"><i class="fa-solid fa-droplet" aria-hidden="true"></i><span>' + escapeHtml(config.weatherLabelHumidity || '') + '</span></div>'
                     +   '<div class="app-landing-weather-card__value">' + escapeHtml(cw.humidity) + '%</div>'
                     + '</div>';
            }
            if (cw.windVelocity !== '') {
                html += '<div class="app-landing-weather-card">'
                     +   '<div class="app-landing-weather-card__head"><i class="fa-solid fa-wind" aria-hidden="true"></i><span>' + escapeHtml(config.weatherLabelWind || '') + '</span></div>'
                     +   '<div class="app-landing-weather-card__value">' + escapeHtml(cw.windVelocity) + ' km/h</div>'
                     +   (cw.windDirection ? '<div class="app-landing-weather-card__sub">' + escapeHtml(cw.windDirection) + '</div>' : '')
                     + '</div>';
            }
            if (cw.pressure !== '') {
                html += '<div class="app-landing-weather-card">'
                     +   '<div class="app-landing-weather-card__head"><i class="fa-solid fa-gauge-high" aria-hidden="true"></i><span>' + escapeHtml(config.weatherLabelPressure || '') + '</span></div>'
                     +   '<div class="app-landing-weather-card__value">' + escapeHtml(cw.pressure) + '</div>'
                     +   '<div class="app-landing-weather-card__sub">hPa</div>'
                     + '</div>';
            }
            if (cw.sensation !== '') {
                html += '<div class="app-landing-weather-card">'
                     +   '<div class="app-landing-weather-card__head"><i class="fa-solid fa-temperature-high" aria-hidden="true"></i><span>' + escapeHtml(config.weatherLabelFeelsLike || '') + '</span></div>'
                     +   '<div class="app-landing-weather-card__value">' + escapeHtml(cw.sensation) + '°</div>'
                     + '</div>';
            }
            html += '</div>';
            return html;
        }

        function renderHourlyTab(hourly) {
            if (!Array.isArray(hourly) || !hourly.length) {
                return '<div class="app-landing-weather-state" data-state="empty">' + escapeHtml(config.weatherEmpty || '') + '</div>';
            }
            var rainLabel = escapeHtml(config.weatherLabelRainShort || 'Chuva');
            var rows = hourly.slice(0, 16).map(function (h) {
                var temp = (h.temperature !== null && h.temperature !== undefined) ? (h.temperature + '°') : '—';
                var rain = (h.rain && h.rain > 0) ? (Number(h.rain).toFixed(1).replace(/\.0$/, '') + ' mm') : '';
                return '<div class="app-landing-weather-hour-row">'
                     +   '<span class="app-landing-weather-hour-row__hour">' + escapeHtml(hourFromIso(h.date)) + '</span>'
                     +   '<i class="' + weatherIconClassList('app-landing-weather-hour-row__icon', h.iconClass || 'fas fa-cloud', h.iconTone) + '" aria-hidden="true"></i>'
                     +   '<span class="app-landing-weather-hour-row__temp">' + escapeHtml(temp) + '</span>'
                     +   '<span class="app-landing-weather-hour-row__rain">'
                     +     (rain ? '<i class="fa-solid fa-droplet" aria-hidden="true"></i> ' + escapeHtml(rain) : '')
                     +   '</span>'
                     + '</div>';
            }).join('');
            return '<div class="app-landing-weather-hour-list">' + rows + '</div>';
        }

        function renderDailyTab(daily) {
            if (!Array.isArray(daily) || !daily.length) {
                return '<div class="app-landing-weather-state" data-state="empty">' + escapeHtml(config.weatherEmpty || '') + '</div>';
            }
            var rows = daily.map(function (d) {
                var min = (d.tempMin !== null && d.tempMin !== undefined) ? (d.tempMin + '°') : '—';
                var max = (d.tempMax !== null && d.tempMax !== undefined) ? (d.tempMax + '°') : '—';
                var rain = (d.rainProb !== null && d.rainProb !== undefined && d.rainProb > 0)
                    ? (d.rainProb + '%') : '';
                return '<div class="app-landing-weather-day-row">'
                     +   '<div class="app-landing-weather-day-row__head">'
                     +     '<span class="app-landing-weather-day-row__day">' + escapeHtml(d.dayLabel || d.dayShort || '') + '</span>'
                     +     '<span class="app-landing-weather-day-row__num">' + escapeHtml(d.dayNum || '') + '</span>'
                     +   '</div>'
                     +   '<i class="' + weatherIconClassList('app-landing-weather-day-row__icon', d.iconClass || 'fas fa-cloud', d.iconTone) + '" aria-hidden="true"></i>'
                     +   '<div class="app-landing-weather-day-row__phrase">' + escapeHtml(d.phrase || '') + '</div>'
                     +   '<div class="app-landing-weather-day-row__temps">'
                     +     '<span class="app-landing-weather-day-row__max">' + escapeHtml(max) + '</span>'
                     +     '<span class="app-landing-weather-day-row__min">' + escapeHtml(min) + '</span>'
                     +   '</div>'
                     +   (rain
                            ? '<div class="app-landing-weather-day-row__rain"><i class="fa-solid fa-droplet" aria-hidden="true"></i>' + escapeHtml(rain) + '</div>'
                            : '<div class="app-landing-weather-day-row__rain"></div>')
                     + '</div>';
            }).join('');
            return '<div class="app-landing-weather-day-list">' + rows + '</div>';
        }

        function bindTabs(rootEl) {
            var tabs = rootEl.querySelectorAll('[data-weather-tab]');
            var panels = rootEl.querySelectorAll('[data-weather-panel]');
            tabs.forEach(function (tab) {
                tab.addEventListener('click', function () {
                    var name = tab.getAttribute('data-weather-tab');
                    tabs.forEach(function (t) {
                        var active = t === tab;
                        t.classList.toggle('is-active', active);
                        t.setAttribute('aria-selected', active ? 'true' : 'false');
                    });
                    panels.forEach(function (p) {
                        var match = p.getAttribute('data-weather-panel') === name;
                        if (match) p.removeAttribute('hidden');
                        else p.setAttribute('hidden', '');
                    });
                });
            });
        }

        function renderSourceSwitch() {
            if (!hasRadioWeather) {
                return '';
            }
            var lblRadio = escapeHtml(config.weatherLabelSourceRadio || 'Cidade da rádio');
            var lblUser  = escapeHtml(config.weatherLabelSourceUser  || 'Sua localização');
            return '<div class="app-landing-weather-source" role="tablist">'
                 +   '<button type="button" class="app-landing-weather-source__btn ' + (activeSource === 'radio' ? 'is-active' : '') + '"'
                 +     ' role="tab" aria-selected="' + (activeSource === 'radio' ? 'true' : 'false') + '"'
                 +     ' data-weather-source="radio">'
                 +     '<i class="fa-solid fa-tower-broadcast" aria-hidden="true"></i> ' + lblRadio
                 +   '</button>'
                 +   '<button type="button" class="app-landing-weather-source__btn ' + (activeSource === 'user' ? 'is-active' : '') + '"'
                 +     ' role="tab" aria-selected="' + (activeSource === 'user' ? 'true' : 'false') + '"'
                 +     ' data-weather-source="user">'
                 +     '<i class="fa-solid fa-location-crosshairs" aria-hidden="true"></i> ' + lblUser
                 +   '</button>'
                 + '</div>';
        }

        function renderWeather(weather) {
            if (!weather || !weather.currentWeather) {
                /* Mesmo em "empty", queremos mostrar o switch para o user
                   ter como voltar para a outra fonte. */
                var emptyHtml = renderSourceSwitch()
                    + '<div class="app-landing-weather-state" data-state="empty">' + escapeHtml(config.weatherEmpty || '') + '</div>';
                contentEl.innerHTML = emptyHtml;
                bindSourceSwitch(contentEl);
                setWeatherUi('content');
                return;
            }

            var labelNow    = escapeHtml(config.weatherLabelTabNow    || 'Agora');
            var labelHourly = escapeHtml(config.weatherLabelTabHourly || 'Próximas horas');
            var labelDaily  = escapeHtml(config.weatherLabelTabDaily  || 'Próximos dias');

            var html = renderSourceSwitch();
            html += renderHero(weather);
            html += renderHourlyStrip(weather.hourly);

            html += '<nav class="app-landing-weather-tabs" role="tablist">'
                 +    '<button type="button" class="app-landing-weather-tab is-active" role="tab" aria-selected="true" data-weather-tab="now">' + labelNow + '</button>'
                 +    '<button type="button" class="app-landing-weather-tab" role="tab" aria-selected="false" data-weather-tab="hourly">' + labelHourly + '</button>'
                 +    '<button type="button" class="app-landing-weather-tab" role="tab" aria-selected="false" data-weather-tab="daily">' + labelDaily + '</button>'
                 +  '</nav>';

            html += '<div class="app-landing-weather-panel" data-weather-panel="now">' + renderNowTab(weather) + '</div>';
            html += '<div class="app-landing-weather-panel" data-weather-panel="hourly" hidden>' + renderHourlyTab(weather.hourly) + '</div>';
            html += '<div class="app-landing-weather-panel" data-weather-panel="daily" hidden>' + renderDailyTab(weather.daily) + '</div>';

            contentEl.innerHTML = html;
            bindTabs(contentEl);
            bindSourceSwitch(contentEl);
            setWeatherUi('content');
        }

        function bindSourceSwitch(rootEl) {
            var btns = rootEl.querySelectorAll('[data-weather-source]');
            btns.forEach(function (b) {
                b.addEventListener('click', function () {
                    var src = b.getAttribute('data-weather-source');
                    if (src === activeSource) return;
                    activeSource = src;
                    loadAndRenderWeather();
                });
            });
        }

        function showGeoState(stateMessage) {
            var lblRetry = escapeHtml(config.weatherLabelRetry || 'Tentar novamente');
            contentEl.innerHTML = renderSourceSwitch()
                + '<div class="app-landing-weather-state" data-state="' + stateMessage.kind + '">'
                +   '<p class="app-landing-weather-geo-msg">' + escapeHtml(stateMessage.text || '') + '</p>'
                +   (stateMessage.kind === 'error' || stateMessage.kind === 'denied'
                        ? '<button type="button" class="app-landing-weather-geo-retry" data-weather-geo-retry>' + lblRetry + '</button>'
                        : '')
                + '</div>';
            bindSourceSwitch(contentEl);
            var retry = contentEl.querySelector('[data-weather-geo-retry]');
            if (retry) {
                retry.addEventListener('click', function () {
                    userCoords = null;
                    weatherCacheUser = null;
                    loadAndRenderWeather();
                });
            }
            setWeatherUi('content');
        }

        function requestGeolocation() {
            return new Promise(function (resolve, reject) {
                if (!navigator.geolocation) {
                    reject({ kind: 'unsupported' });
                    return;
                }
                navigator.geolocation.getCurrentPosition(
                    function (pos) {
                        resolve({
                            lat: pos.coords.latitude,
                            lon: pos.coords.longitude
                        });
                    },
                    function (err) {
                        reject({
                            kind: err && err.code === err.PERMISSION_DENIED ? 'denied' : 'error',
                            error: err
                        });
                    },
                    { enableHighAccuracy: false, timeout: 10000, maximumAge: 5 * 60 * 1000 }
                );
            });
        }

        function fetchWeatherJson(url) {
            return fetch(url, { credentials: 'same-origin' })
                .then(function (r) {
                    if (!r.ok) throw new Error('http');
                    return r.json();
                })
                .then(function (data) {
                    if (!data || data.success === false || !data.weather) {
                        throw new Error('api');
                    }
                    return data.weather;
                });
        }

        function loadAndRenderWeather() {
            if (activeSource === 'user') {
                /* Cache em memoria — nao refaz geolocation+fetch toda vez. */
                if (weatherCacheUser && weatherCacheUser.currentWeather) {
                    renderWeather(weatherCacheUser);
                    return;
                }
                setWeatherUi('loading', config.weatherLoadingGeo || config.weatherLoading || '');

                var ensureCoords = userCoords
                    ? Promise.resolve(userCoords)
                    : requestGeolocation().then(function (coords) { userCoords = coords; return coords; });

                ensureCoords
                    .then(function (coords) {
                        var sep = weatherAtUrlBase.indexOf('?') === -1 ? '?' : '&';
                        var url = weatherAtUrlBase + sep + 'lat=' + encodeURIComponent(coords.lat) + '&lon=' + encodeURIComponent(coords.lon);
                        return fetchWeatherJson(url);
                    })
                    .then(function (weather) {
                        weatherCacheUser = weather;
                        renderWeather(weatherCacheUser);
                    })
                    .catch(function (errInfo) {
                        weatherCacheUser = null;
                        userCoords = null;
                        /* errInfo pode ser do geolocation (objeto com kind)
                           ou um Error genérico do fetch. */
                        if (errInfo && errInfo.kind === 'denied') {
                            showGeoState({ kind: 'denied', text: config.weatherGeoDenied || '' });
                        } else if (errInfo && errInfo.kind === 'unsupported') {
                            showGeoState({ kind: 'unsupported', text: config.weatherGeoUnsupported || '' });
                        } else {
                            showGeoState({ kind: 'error', text: config.weatherGeoError || config.weatherError || '' });
                        }
                    });
                return;
            }

            /* activeSource === 'radio' */
            if (!hasRadioWeather || !config.weatherFetchUrl) {
                activeSource = 'user';
                loadAndRenderWeather();
                return;
            }
            if (weatherCacheRadio && weatherCacheRadio.currentWeather) {
                renderWeather(weatherCacheRadio);
                return;
            }
            setWeatherUi('loading', config.weatherLoading || '');
            fetchWeatherJson(config.weatherFetchUrl)
                .then(function (weather) {
                    weatherCacheRadio = weather;
                    renderWeather(weatherCacheRadio);
                })
                .catch(function () {
                    weatherCacheRadio = null;
                    setWeatherUi('error', config.weatherError || '');
                });
        }

        if (drawer) {
            drawer.querySelectorAll('[data-app-landing-weather-close]').forEach(function (el) {
                el.addEventListener('click', closeWeatherDrawer);
            });
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
                    closeWeatherDrawer();
                }
            });
        }

        weatherBtns.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                if (!weatherEnabled || !drawer) return;
                openWeatherDrawer();
                loadAndRenderWeather();
            });
        });
    }

    initAppLandingWeather(cfg);

    /**
     * Now Playing (Shazam) — identificacao automatica da musica em curso.
     *
     * Mesma engine usada no rp-music-player do home (music-identifier.js):
     *   - Captura ~8s do stream via /ajax/capture-stream.php
     *   - Envia para /ajax/identify-music.php (Shazam-like backend)
     *   - Resposta: { success, title, artist, coverart, label }
     *
     * No mock screen alternamos entre dois estados:
     *   - Fallback (logo + descricao da radio): default
     *   - Track (capa + titulo + artista): quando ha resultado valido
     *
     * Pause / erro / sem resultado → volta para fallback automaticamente
     * (timer cancelado, UI restaurada).
     */
    function initAppLandingNowPlaying(config) {
        var enabled = !!(config && config.nowPlayingEnabled);
        if (!enabled) return;
        if (typeof window.MusicIdentifier === 'undefined') return;

        var audio = document.getElementById('app-landing-stream-audio');
        var body  = document.querySelector('.app-mock-body');
        if (!audio || !body) return;

        var fallbackEl = body.querySelector('[data-now-playing-fallback]');
        var trackEl    = body.querySelector('[data-now-playing-track]');
        var coverImg   = body.querySelector('[data-now-playing-cover]');
        var titleEl    = body.querySelector('[data-now-playing-title]');
        var artistEl   = body.querySelector('[data-now-playing-artist]');
        var eyebrowEl  = body.querySelector('[data-now-playing-eyebrow]');
        if (!fallbackEl || !trackEl || !titleEl || !artistEl) return;

        var identifier = new window.MusicIdentifier({
            endpoint: config.nowPlayingEndpoint || '/ajax/identify-music.php',
            recordDuration: config.nowPlayingRecordMs || 8000,
            radioId: config.radioId || config.id || 0,
            onSuccess: function (result) {
                renderTrack(result);
            },
            onError: function () {
                /* Nao identificou: volta para fallback. Nao mostra toast aqui
                   porque o ciclo e em loop e seria spam visual. */
                restoreFallback();
            }
        });

        var loopTimerId = null;
        var inflight = false;
        var lastSig = '';   /* titulo|artista do ultimo render — evita re-render desnecessario */

        function setEyebrow(text) {
            if (eyebrowEl) eyebrowEl.textContent = text || (config.nowPlayingLabelIdle || '');
        }

        function setCover(url) {
            if (!coverImg) return;
            var hasUrl = typeof url === 'string' && url.trim() !== '';
            if (hasUrl) {
                coverImg.src = url;
                trackEl.classList.remove('is-no-cover');
                coverImg.onerror = function () {
                    trackEl.classList.add('is-no-cover');
                };
            } else {
                coverImg.removeAttribute('src');
                trackEl.classList.add('is-no-cover');
            }
        }

        function applyTrackContent(title, artist, coverart) {
            titleEl.textContent = title;
            artistEl.textContent = artist;
            setCover(coverart);
            setEyebrow(config.nowPlayingLabelIdle || '');
        }

        function renderTrack(result) {
            var title  = result && result.title ? String(result.title).trim() : '';
            var artist = result && result.artist ? String(result.artist).trim() : '';
            if (!title) {
                restoreFallback();
                return;
            }
            var sig = title + '|' + artist;
            if (sig === lastSig) return;  /* mesma faixa — nao re-renderiza */
            var isFirstTrack = (lastSig === '');
            lastSig = sig;

            /* Primeira musica: nao tem o que fazer cross-fade contra (a area
               ainda mostrava o fallback). Aplica direto. */
            if (isFirstTrack) {
                applyTrackContent(title, artist, result && result.coverart);
                fallbackEl.setAttribute('hidden', '');
                trackEl.removeAttribute('hidden');
                body.setAttribute('data-now-playing-state', 'track');
                return;
            }

            /* Troca de musica: aplica classe "is-changing" que fade-outs e
               sobe levemente a capa + metadados, troca o conteudo no meio
               da transicao, e remove a classe para o fade-in. */
            trackEl.classList.add('is-changing');
            /* Espera o tempo da transicao CSS de "saida" (ver radio-app-landing.css)
               antes de trocar o conteudo. transitionend nao e confiavel aqui
               porque varios elementos transicionam ao mesmo tempo. */
            window.setTimeout(function () {
                applyTrackContent(title, artist, result && result.coverart);
                /* Forca reflow para garantir que o browser registre a mudanca
                   de classe antes da remocao (senao alguns navegadores pulam
                   a transicao de volta). */
                void trackEl.offsetWidth;
                trackEl.classList.remove('is-changing');
            }, 220);
        }

        function restoreFallback() {
            lastSig = '';
            trackEl.setAttribute('hidden', '');
            fallbackEl.removeAttribute('hidden');
            body.setAttribute('data-now-playing-state', 'idle');
        }

        function stopLoop() {
            if (loopTimerId !== null) {
                clearTimeout(loopTimerId);
                loopTimerId = null;
            }
            try { identifier.cancelRecording(); } catch (e) { /* ignore */ }
            inflight = false;
        }

        function runIdentification() {
            if (audio.paused || inflight) return;
            inflight = true;
            /* Eyebrow fica fixo em "Tocando agora" enquanto existe um track
               renderizado — alternar para "Identificando..." a cada ciclo
               criava um flicker desnecessario na info ja confirmada. */
            identifier.identifyCurrentTrack(audio)
                .catch(function () { /* tratado por onError do identifier */ })
                .then(function () {
                    inflight = false;
                });
        }

        function scheduleNext(initialDelay) {
            if (loopTimerId !== null) clearTimeout(loopTimerId);
            var delay = typeof initialDelay === 'number'
                ? initialDelay
                : (config.nowPlayingIntervalMs || 30000);
            loopTimerId = window.setTimeout(function () {
                loopTimerId = null;
                runIdentification();
                scheduleNext();  /* re-agenda com intervalo padrao */
            }, delay);
        }

        audio.addEventListener('playing', function () {
            if (audio.paused) return;
            /* Pequeno delay para o stream estabilizar antes da 1ª captura. */
            scheduleNext(2500);
        });
        audio.addEventListener('pause', function () {
            stopLoop();
            restoreFallback();
        });
        audio.addEventListener('ended', function () {
            stopLoop();
            restoreFallback();
        });
        audio.addEventListener('error', function () {
            stopLoop();
            restoreFallback();
        });
    }

    initAppLandingNowPlaying(cfg);

    /**
     * RDS / ICY metadata — busca o título da música em curso enviado pelo
     * próprio servidor da rádio (Icecast/Shoutcast). Mais confiável que o
     * Shazam porque vem da fonte; usado no fallback view (no lugar da
     * descrição) quando há texto válido.
     *
     * Endpoint: radio.php?ajax=icy_metadata&id={radioId}
     * Resposta: { success, streamTitle, title, artist }
     */
    function initAppLandingRds(config) {
        if (!config || !config.rdsEnabled || !config.rdsFetchUrl) return;

        var fallbackEl  = document.querySelector('[data-now-playing-fallback]');
        if (!fallbackEl) return;

        var rdsBox      = fallbackEl.querySelector('[data-now-playing-rds]');
        var rdsTitleEl  = fallbackEl.querySelector('[data-now-playing-rds-title]');
        var rdsArtistEl = fallbackEl.querySelector('[data-now-playing-rds-artist]');
        var descEl      = fallbackEl.querySelector('[data-now-playing-description]');
        if (!rdsBox || !rdsTitleEl || !descEl) return;

        var audio = document.getElementById('app-landing-stream-audio');
        var pollTimerId = null;
        var lastTitle = '';
        var inflight = false;

        /* Strings que indicam metadata "sem música" — evitamos sobrescrever
           a descrição com vinhetas. Lista mínima, conservadora. */
        var noiseRe = /^(advert|comercial|publicidade|jingle|vinheta|station id|id da r|\s*)$/i;

        function showRds(title, artist) {
            rdsTitleEl.textContent = title;
            if (artist) {
                rdsArtistEl.textContent = artist;
                rdsArtistEl.removeAttribute('hidden');
            } else {
                rdsArtistEl.textContent = '';
                rdsArtistEl.setAttribute('hidden', '');
            }
            rdsBox.removeAttribute('hidden');
            descEl.setAttribute('hidden', '');
        }

        function hideRds() {
            rdsBox.setAttribute('hidden', '');
            rdsArtistEl.setAttribute('hidden', '');
            descEl.removeAttribute('hidden');
            lastTitle = '';
        }

        function applyMetadata(data) {
            if (!data || data.success === false) return;
            var streamTitle = (data.streamTitle || '').trim();
            var title  = (data.title || '').trim();
            var artist = (data.artist || '').trim();

            if (streamTitle === '' || noiseRe.test(streamTitle)) {
                hideRds();
                return;
            }

            /* Se o parser conseguiu separar artista-musica, usa os campos
               separados; senão mostra o streamTitle bruto na linha de título. */
            var displayTitle  = title !== '' ? title : streamTitle;
            var displayArtist = title !== '' ? artist : '';

            var sig = displayTitle + '|' + displayArtist;
            if (sig === lastTitle) return;
            lastTitle = sig;

            showRds(displayTitle, displayArtist);
        }

        function fetchRds() {
            if (inflight) return;
            inflight = true;
            fetch(config.rdsFetchUrl, { credentials: 'same-origin', cache: 'no-store' })
                .then(function (r) { return r.ok ? r.json() : null; })
                .then(applyMetadata)
                .catch(function () { /* silencioso — proximo tick tenta de novo */ })
                .then(function () { inflight = false; });
        }

        function startLoop() {
            stopLoop();
            fetchRds();
            pollTimerId = window.setInterval(fetchRds, config.rdsIntervalMs || 15000);
        }

        function stopLoop() {
            if (pollTimerId !== null) {
                clearInterval(pollTimerId);
                pollTimerId = null;
            }
        }

        /* Para o RDS continuar correndo quando pausado: a info que está
           tocando no servidor existe independente de o utilizador estar
           ouvindo. Mas se a aba sair de foco / for fechar, paramos. */
        if (audio) {
            audio.addEventListener('playing', startLoop);
            audio.addEventListener('pause',   function () { /* mantém ativo */ });
            audio.addEventListener('error',   stopLoop);
            audio.addEventListener('ended',   stopLoop);
        }
        document.addEventListener('visibilitychange', function () {
            if (document.hidden) {
                stopLoop();
            } else {
                startLoop();
            }
        });

        /* Primeira busca imediata para que o fallback view não comece com
           a descrição se já há RDS disponível antes do primeiro play. */
        startLoop();
    }

    initAppLandingRds(cfg);
})();

}
